export enum SoundAssetNames {
	Boing = "boing",
	Glop = "glop1",
	Busy = "busy",
	Alarm = "alarm",
	CrateCollected = "collect",
	NewCrate = "request"
}
